import { Box, Flex, FormButton, PaperSection } from '@shared/components';

import {
  QuestionReviewResultForm,
  QuestionReviewResultDescriptionForm,
  QuestionReviewResultView,
  QuestionReviewResultDescriptionView,
} from '..';
import { mappedQuestionReviewStatus } from '../../constants';
import {
  type QuestionReviewResultVerdict,
  QuestionReviewTaskQuestionDetailsFormProvider,
  useQuestionReviewTaskQuestionDetails,
} from '../../providers';
import { getQuestionReviewResultVariant, QuestionReviewResultVariant } from '../../utils/';

function getReviewResultSectionFromVariant(variant: QuestionReviewResultVariant | null) {
  switch (variant) {
    case QuestionReviewResultVariant.EDITABLE:
      return {
        reviewResult: <QuestionReviewResultForm />,
        description: <QuestionReviewResultDescriptionForm />,
      };
    case QuestionReviewResultVariant.READONLY:
      return {
        reviewResult: <QuestionReviewResultView />,
        description: <QuestionReviewResultDescriptionView />,
      };
    case QuestionReviewResultVariant.HIDDEN:
    default:
      return {
        reviewResult: null,
        description: null,
      };
  }
}

export default function QuestionReviewTaskReviewResultSection() {
  const {
    workflowRoles,
    mainTaskDetails: { currentWorkflowStep },
    comment,
    verdict,
  } = useQuestionReviewTaskQuestionDetails();

  const taskStatus =
    mappedQuestionReviewStatus[currentWorkflowStep.code as keyof typeof mappedQuestionReviewStatus];

  const variant = getQuestionReviewResultVariant(workflowRoles, taskStatus);

  const { reviewResult, description } = getReviewResultSectionFromVariant(variant);

  const shouldDisplaySaveButton = variant === QuestionReviewResultVariant.EDITABLE;

  if (reviewResult === null && description === null) {
    return null;
  }

  return (
    <QuestionReviewTaskQuestionDetailsFormProvider
      initialValues={{
        result: verdict?.verdict as unknown as QuestionReviewResultVerdict,
        description: comment?.content,
      }}
    >
      <Flex sx={(theme) => ({ gap: theme.spacing(6), flexDirection: 'column' })}>
        <PaperSection title='Review Result'>
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              gap: theme.spacing(6),
              p: theme.spacing(6),
            })}
          >
            {reviewResult}
            {description}
          </Flex>
        </PaperSection>
        {shouldDisplaySaveButton ? (
          <Box>
            <FormButton label='Save' />
          </Box>
        ) : null}
      </Flex>
    </QuestionReviewTaskQuestionDetailsFormProvider>
  );
}
